import { Component, OnInit } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { HttpClientModule } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { firstValueFrom } from 'rxjs';
import { TokenService } from '../../services/token/token.service';
import { FormatService } from '../../services/format/format.service';
import { ActivatedRoute, Router } from '@angular/router';
import { StorageService } from '../../services/storage/storage.service';
import { Location } from '@angular/common';

@Component({
  selector: 'app-fb-instagram-callback',
  standalone: true,
  imports: [HttpClientModule],
  providers: [HttpClient, TokenService],
  templateUrl: './fb-instagram-callback.component.html',
  styleUrl: './fb-instagram-callback.component.scss'
})
export class FbInstagramCallbackComponent implements OnInit {

  instagramAccount: {
    account_type: string;
    creatorId: string;
    followers_count: number;
    instagram_account_id: string;
    name: string;
    profile_picture_url: string;
    user_id: string;
    username: string;
    follows_count: number;
    media_count: number;
  } | undefined;

  connectionError: boolean = false;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private tokenService: TokenService,
    public formatService: FormatService,
    private storageService: StorageService,
    private location: Location
  ) { }

  ngOnInit() {
    console.log('FbInstagramCallbackComponent ngOnInit()');
    // using string manipulation due to the # in query 
    const tokenObject = this.parseQueryString(location.href.split('#')[1]);
    console.log(tokenObject);

    console.log('FbInstagramCallbackComponent #access_token: ', tokenObject.access_token);


    if (tokenObject.access_token) {
      this.exchangeShortForLong(tokenObject.access_token);
    }
  }

  parseQueryString(queryString: string): any {
    // Create an empty object to store the results.
    const resultObject: any = {};

    // Split the string by the ampersand (&) to get individual key-value pairs.
    const pairs = queryString.split('&');

    // Loop through each key-value pair.
    for (const pair of pairs) {
      // Split each pair by the equals sign (=) to separate the key and value.
      const parts = pair.split('=');

      // Get the key and value. We use decodeURIComponent to handle special characters.
      const key = decodeURIComponent(parts[0]);
      const value = decodeURIComponent(parts[1] || ''); // Handle cases where a value might be missing.

      // Add the key-value pair to our result object.
      resultObject[key] = value;
    }

    // Return the final object.
    return resultObject;
  }

  async exchangeShortForLong(access_token: string) {

    const headers = new HttpHeaders({
      'Content-Type': 'application/json'
    });

    let body = {
      client_id: environment.instagram.clientId,
      client_secret: environment.instagram.ig_app_secret,
      grant_type: 'authorization_code',
      redirect_uri: environment.instagram.redirectUri,
      access_token
    }

    try {
      const tokenResponse = await firstValueFrom(this.tokenService.exchangeShortForLongTokenInstagram(access_token));
      console.log('Token exchange successful:', tokenResponse);

      this.instagramAccount = tokenResponse;

    } catch (error) {
      console.error('Token exchange failed:', error);
    }
  }

  async saveAuthFactors(tokenResponse: any) {
    console.log('saveAuthFactors() ---->');
    console.log(tokenResponse);
  }

  connectAnotherAccount() {
    console.log('Connect another account');

    const businessId = this.storageService.get('businessId');
    const externalId = this.storageService.get('externalId');

    console.log('External ID:', externalId);
    console.log('Business ID:', businessId);
    this.router.navigate([`/connect/${externalId}/${businessId}`]);
  }

  exitBrowser() {
    console.log('Exit browser');
    window.close();
  }
}
